import gql from 'graphql-tag';

export const GET_VEHICLE_LANDING_PAGE = gql`
  query CmsPage($id: String!) {
    cms {
      page(id: $id) {
        documentTitle
        metaTags {
          name
          content
        }
        contentSlots {
          position
          name: id
          cmsComponents {
            __typename
            ... on CmsBannerCarouselComponent {
              name
              slides {
                link {
                  href
                  text
                  target
                }
                image {
                  altText
                  url
                }
              }
              id
            }
            ... on CmsShoppingCategoriesComponent {
              categories {
                link {
                  href
                  text
                  target
                }
                image {
                  altText
                  url
                }
                type
              }
            }
            ... on CmsPromotionCarouselSectionComponent {
              id
              name
              position
              typeName
              cmsComponents {
                id
                name
                typeName
                startDate
                endDate
                image {
                  url
                  altText
                }
                seeProductsLink {
                  href
                  target
                  text
                }
                seeDetailsLink {
                  href
                  target
                  text
                }
              }
            }
            ... on CmsHtmlComponent {
              __typename
              name: id
              html
            }
            ... on CmsCalloutComponent {
              __typename
              description
              image {
                altText
                url
              }
              title
            }
          }
        }
        source
      }
    }
  }
`;
